/**
 * Meeting data model for business trips
 */

export const createMeeting = ({
  id = null,
  companyName = '',
  meetingTitle = '',
  date = '',
  time = '',
  address = '',
  notes = '',
  createdAt = new Date().toISOString(),
  updatedAt = new Date().toISOString()
} = {}) => ({
  id: id || `meeting_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
  companyName: companyName.trim(),
  meetingTitle: meetingTitle.trim(),
  date, // YYYY-MM-DD format
  time, // HH:MM format (24-hour)
  address: address.trim(),
  notes: notes.trim(),
  createdAt,
  updatedAt
});

export const validateMeeting = (meeting) => {
  const errors = {};
  
  if (!meeting.companyName) {
    errors.companyName = 'Company name is required';
  }
  
  if (!meeting.meetingTitle) {
    errors.meetingTitle = 'Meeting title is required';
  }
  
  if (!meeting.date) {
    errors.date = 'Date is required';
  } else {
    // Validate date format
    const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
    if (!dateRegex.test(meeting.date)) {
      errors.date = 'Date must be in YYYY-MM-DD format';
    }
  }
  
  if (!meeting.time) {
    errors.time = 'Time is required';
  } else {
    // Validate time format
    const timeRegex = /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/;
    if (!timeRegex.test(meeting.time)) {
      errors.time = 'Time must be in HH:MM format (24-hour)';
    }
  }
  
  if (!meeting.address) {
    errors.address = 'Address is required';
  }
  
  return {
    isValid: Object.keys(errors).length === 0,
    errors
  };
};

export const getMeetingDateTime = (meeting) => {
  if (!meeting.date || !meeting.time) return null;
  return new Date(`${meeting.date}T${meeting.time}:00`);
};

export const formatMeetingTime = (meeting) => {
  const dateTime = getMeetingDateTime(meeting);
  if (!dateTime) return '';
  
  return dateTime.toLocaleString('en-US', {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
  });
};

export const generateGoogleMapsUrl = (address) => {
  if (!address) return '';
  const encodedAddress = encodeURIComponent(address);
  return `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`;
};
